import React from 'react';
import {
  Card,
  Box,
  Typography,
} from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';

const NoDataCard = ({ title = 'Projects By Engine Type' }) => {
  return (
    <Card elevation={1} style={{ width: '100%', border: '1px solid #E5E7EB', borderRadius: 10, backgroundColor: '#FFFFFF', overflow: 'hidden', boxShadow: '0 4px 18px rgba(15, 23, 42, 0.05)' }}>
      {/* Header */}
      <Box style={{ padding: '14px 18px', display: 'flex', alignItems: 'center', borderBottom: '1px solid #EEF0F4' }}>
        <Box style={{ width: 20, height: 20, borderRadius: 6, backgroundColor: '#EEF4FF', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 8 }}>
          <BarChartIcon style={{ color: '#2864E8', fontSize: 20 }} />
        </Box>

        <Typography style={{ fontSize: 16, fontWeight: 800, color: '#172033', lineHeight: 1.2 }}>
          {title}
        </Typography>
      </Box>

      {/* Empty State */}
      <Box style={{ height: '240px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '10px 20px' }}>
        {/* Illustration */}
        <Box style={{ position: 'relative', width: 88, height: 88, borderRadius: '50%', backgroundColor: '#F2F6FD', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
          {/* Chart */}
          <Box style={{ position: 'absolute', left: 27, bottom: 26, width: 16, height: 38, borderRadius: '3px 3px 1px 1px', backgroundColor: '#9BAAC2' }} />

          <Box style={{ position: 'absolute', left: 46, bottom: 26, width: 16, height: 53, borderRadius: '3px 3px 1px 1px', backgroundColor: '#8999B3' }} />

          {/* Baseline */}
          <Box style={{ position: 'absolute', left: 20, bottom: 25, width: 38, height: 2, borderRadius: 2, backgroundColor: '#C7D2E4' }} />

          {/* Search Circle */}
          <Box style={{ position: 'absolute', right: 14, bottom: 25, width: 28, height: 28, border: '5px solid #8395B0', borderRadius: '50%', boxSizing: 'border-box' }} />

          {/* Search Handle */}
          <Box style={{ position: 'absolute', right: 9, bottom: 16, width: 16, height: 5, borderRadius: 5, backgroundColor: '#8395B0', transform: 'rotate(48deg)' }} />

          {/* Decorative strokes */}
          <Box style={{ position: 'absolute', top: 10, right: 14, width: 5, height: 15, borderRadius: 3, backgroundColor: '#A8B9D5', transform: 'rotate(28deg)' }} />

          <Box style={{ position: 'absolute', top: 25, right: 3, width: 15, height: 5, borderRadius: 3, backgroundColor: '#A8B9D5', transform: 'rotate(-25deg)' }} />
        </Box>

        {/* Title */}
        <Typography style={{ fontSize: 15, fontWeight: 700, color: '#25344D', marginBottom: 4 }}>
          No data available
        </Typography>

        {/* Description */}
        <Typography style={{ fontSize: 13, fontWeight: 400, color: '#718099', maxWidth: 320, lineHeight: 1.4 }}>
          There is no data to display for the selected filters.
        </Typography>
      </Box>
    </Card>
  );
};

export default NoDataCard;
